import React from 'react';
import './SupportAdmin.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';

function SupportAdmin() {
  return (
    <div className="support-admin">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Support et Aides" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="breadcrumb-section" style={{display: 'none'}}>
            <h1>Support et Aides</h1>
          </div>

          <div className="support-container">
            <div className="support-section">
              <h2>Centre d'Aide</h2>
              <div className="help-categories">
                <div className="help-card">
                  <h3>📚 Documentation</h3>
                  <p>Consultez notre documentation complète sur l'utilisation du système.</p>
                  <a href="#" className="help-link">Accéder →</a>
                </div>

                <div className="help-card">
                  <h3>❓ FAQ</h3>
                  <p>Réponses aux questions fréquemment posées.</p>
                  <a href="#" className="help-link">Voir les FAQ →</a>
                </div>

                <div className="help-card">
                  <h3>🎓 Tutoriels</h3>
                  <p>Guides pas à pas pour accomplir les tâches principales.</p>
                  <a href="#" className="help-link">Consulter les tutoriels →</a>
                </div>

                <div className="help-card">
                  <h3>☎️ Contacter le Support</h3>
                  <p>Besoin d'aide? Contactez notre équipe de support.</p>
                  <a href="mailto:contact@gsulespalmiers.bj" className="help-link">Envoyer un email →</a>
                </div>
              </div>
            </div>

            <div className="support-section">
              <h2>Ressources Utiles</h2>
              <ul className="resources-list">
                <li><a href="#">Guide d'utilisation du système</a></li>
                <li><a href="#">Gestion des utilisateurs</a></li>
                <li><a href="#">Sécurité et bonnes pratiques</a></li>
                <li><a href="#">Configuration des paramètres</a></li>
              </ul>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default SupportAdmin;
